import { render } from "./HistoryBlock.vue?vue&type=template&id=b0fc399c&scoped=true"
import script from "./HistoryBlock.vue?vue&type=script&lang=js"
export * from "./HistoryBlock.vue?vue&type=script&lang=js"

import "./HistoryBlock.vue?vue&type=style&index=0&id=b0fc399c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0fc399c"]])

export default __exports__